export default "__VITE_ASSET__Ce00IDlr__"